import { Namespace } from "@cirrus/fe-lib"

export const core = {
  domain: Namespace.domain("core"),
}
